<template>
  <base-card
    v-if="EntityCardMixin_CopySource"
    :title="EntityCardMixin_Title"
  >
    <v-row>
      <base-field
        v-if="EntityCardMixin_CopySource.description"
        v-model="EntityCardMixin_CopySource.description"
        base-field-container-type="v-col"
        :disabled="EntityCardMixin_Disabled"
        :label="TextMixin_GetLabel('description')"
        lg="12"
        md="12"
        :readonly="EntityCardMixin_Readonly"
        :rules="[validationMixin.rules.required, validationMixin.rules.charactersMax(EntityCardMixin_CopySource.description.value, 255)]"
      />
      <base-field
        v-if="EntityCardMixin_CopySource.information"
        v-model="EntityCardMixin_CopySource.information"
        base-field-container-type="v-col"
        base-field-type="textarea"
        :disabled="EntityCardMixin_Disabled"
        :label="TextMixin_GetLabel('information')"
        lg="12"
        md="12"
        :readonly="EntityCardMixin_Readonly"
        :rules="[validationMixin.rules.required]"
      />
    </v-row>
  </base-card>
</template>

<script>
import EntityCardMixin from '@/mixins/entity-card-mixin'

export default {
  name: 'EntityCardUserManagementProfilesDetailGeneralInformation',
  mixins: [
    EntityCardMixin
  ],
  mounted () {
    this.Initialize()
  },
  methods: {
    Initialize () {
      this.EntityCardMixin_SetDefaultTitle('generalInformation')
    }
  }
}
</script>
